/**
 * Keep keyboard focus in sync with the theme's aria-hidden UI state.
 *
 * Stiletto toggles aria-hidden on menus, drawers, accordions, filters, and
 * modals, but focusable descendants otherwise remain in the tab order while
 * those components are closed. The inert attribute follows the same state and
 * is supported by the theme's existing inert polyfill for older browsers.
 */
(function () {
  const syncInert = (element) => {
    if (!(element instanceof HTMLElement)) return;

    if (element.getAttribute('aria-hidden') === 'true') {
      element.setAttribute('inert', '');
    } else {
      element.removeAttribute('inert');
    }
  };

  const init = () => {
    document.querySelectorAll('[aria-hidden]').forEach(syncInert);

    new MutationObserver((mutations) => {
      mutations.forEach(({ target }) => syncInert(target));
    }).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
